import React, { useRef } from 'react'
import { trans } from '../../../../_providers/Translation'
import Help from '../../../partials/Help'
import Dropdown from '@/components/partials/Dropdown'
import DateRange from '@/components/partials/DateRange'
import DatePicker from '@/components/partials/Date'

const SubscriptionFilter = (props) => {
    const categoriesDropdownRef = useRef(null)
    const contractorsDropdownRef = useRef(null)

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleClearFilters = () => {
        props.handleSearch('name', '')
        categoriesDropdownRef.current.reset()
        contractorsDropdownRef.current.reset()
        props.handleSearch('category_id', '')
        props.handleSearch('contractor_id', '')
        props.handleSearch('start_date', '')
        props.handleSearch('end_date', '')
        props.handleSearch('due_to_pay', '')
    }

    const handleCategory = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('category_id', val)
        }
    }

    const handleContractor = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('contractor_id', val)
        }
    }

    return (
        <>
            <form className="filter-standard">
                <div className='col'>
                    <input
                        type='search'
                        name='name'
                        onChange={handleSearch}
                        onKeyUp={handleSearch}
                        value={props.filter.name}
                        placeholder={trans('labels.search')}
                    />
                </div>
                <div className='col'>
                    <select
                        name='status'
                        onChange={handleSearch}
                        value={props.filter.status}
                    >
                        <option value=''>{trans('filters.allStatuses')}</option>
                        <option value='active'>{trans('filters.active')}</option>
                        <option value='inactive'>{trans('filters.inactive')}</option>
                    </select>
                </div>
                <div className='col'>
                    <Dropdown
                        inputIdValue={Number(props.filter.category_id)}
                        url="partners/categories/all"
                        renderText={data => {
                            return data.name
                        }}
                        onChange={data => {
                            handleCategory(data)
                        }}
                        inputPlaceholder={trans('labels.category')}
                        ref={categoriesDropdownRef}
                    />
                </div>
                <div className='col'>
                    <Dropdown
                        inputIdValue={Number(props.filter.contractor_id)}
                        url="contractors/dropdown-list"
                        renderText={data => {
                            return data.name
                        }}
                        onChange={data => {
                            handleContractor(data)
                        }}
                        inputPlaceholder={trans('tables.contractor')}
                        ref={contractorsDropdownRef}
                    />
                </div>
                <div className='col'>
                    <DatePicker
                        date={props.filter.due_to_pay}
                        onDateChange={(date) => {
                            props.handleSearch('due_to_pay', date)
                        }}
                        placeholder={trans('labels.dueToPay')}
                    />
                </div>
                <div className='col'>
                    <DateRange
                        startDate={props.filter.start_date}
                        endDate={props.filter.end_date}
                        onStartDateChange={(date) => {
                            props.handleSearch('start_date', date)
                        }}
                        onEndDateChange={(date) => {
                            props.handleSearch('end_date', date)
                        }}
                    />
                </div>

                <div className='col'>
                    <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                        {trans('buttons.clearFilter')}
                    </button>
                </div>
            </form>
        </>
    )
}
export default SubscriptionFilter